import { Lliam } from './lliam';
import { MockLliam } from './mock-lliam';

/*
 * http://gitlab.locuslabs.com/code/lliam-client/blob/master/docs/DefaultApi.md
 *
 * The Lliam api manages a users permissions
 * The one call we care about is getting the user policy
 * The policy determines what permissions a user has and if they have read / write access to a venue and mapnotes
 * The VMS currently uses the policy to check map note permissions
 * Using the policy allows us to deprecate using the custom:MapNotes attribute in cognito
 */
const LliamLoader = (isMock, include = true) => {
    if (!include) return {};

    return isMock ? MockLliam : Lliam;
};

export { LliamLoader };
